export enum DocumentType {
  VEHICLE_PHOTOS = 'vehicle-photos',
  DRIVER_SKILLS_AND_CERTIFICATIONS = 'driver-skills-and-certifications',
  PROOF_OF_INSURANCE = 'proof-of-insurance',
  PROFILE_PHOTO = 'profile-photo',
  DRIVER_LICENSE_FRONT = 'driver-license-front',
  DRIVER_LICENSE_BACK = 'driver-license-back',
}

export type Document = {
  name: string;
  url: string;
};

export type ExistingFile = {
  id?: string;
  signed_id: string | null;
  url?: string | null;
  filename?: string | null;
  _destroy?: boolean;
};

export enum SigningDocumentEnum {
  CONTRACTOR_AGREEMENTS = 'contractor-agreements',
  PAIC = 'paic',
}

export enum DocumentToSignStatus {
  COMPLETED = 'completed',
  SENT = 'sent',
  PROCESSING = 'processing',
}

export type DocumentToSign = {
  status?: DocumentToSignStatus | null;
  name: string;
  document_details_url?: string | null;
  docusign_template_id: string;
  envelope_id?: string | null;
};

export type DocusignEmbedUrlResponse = {
  url: string;
  envelope_id: string;
};
